var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdministratorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2044 17.667H21.7044C23.2515 17.667 24.7353 18.2816 25.8292 19.3755C26.9232 20.4695 27.5378 21.9532 27.5378 23.5003V30.5003C27.5378 31.1192 27.2919 31.7127 26.8543 32.1502C26.4168 32.5878 25.8233 32.8337 25.2044 32.8337H14.7044C14.0856 32.8337 13.4921 32.5878 13.0545 32.1502C12.6169 31.7127 12.3711 31.1192 12.3711 30.5003V23.5003C12.3711 21.9532 12.9857 20.4695 14.0796 19.3755C15.1736 18.2816 16.6573 17.667 18.2044 17.667Z",
    fill: "#C7CED5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 16.4993C22.578 16.4993 24.6673 14.41 24.6673 11.8327C24.6673 9.25535 22.578 7.16602 20.0007 7.16602C17.4233 7.16602 15.334 9.25535 15.334 11.8327C15.334 14.41 17.4233 16.4993 20.0007 16.4993Z",
    fill: "#C7CED5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4173 31.6667C28.6725 31.6667 30.5007 29.8385 30.5007 27.5833C30.5007 25.3282 28.6725 23.5 26.4173 23.5C24.1622 23.5 22.334 25.3282 22.334 27.5833C22.334 29.8385 24.1622 31.6667 26.4173 31.6667Z",
    fill: "#6B758F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.416 29.334C27.3825 29.334 28.166 28.5505 28.166 27.584C28.166 26.6175 27.3825 25.834 26.416 25.834C25.4495 25.834 24.666 26.6175 24.666 27.584C24.666 28.5505 25.4495 29.334 26.416 29.334Z",
    fill: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8971 22.3447H24.9805V24.6781H27.8971V22.3447Z",
    fill: "#6B758F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6302 23.6889L21.1719 26.2148L23.1926 27.3815L24.6509 24.8556L22.6302 23.6889Z",
    fill: "#6B758F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.153 28.9301L22.6113 31.4561L24.6321 30.2894L23.1737 27.7635L21.153 28.9301Z",
    fill: "#6B758F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9349 32.8223H27.8516V30.4889H24.9349V32.8223Z",
    fill: "#6B758F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2116 31.4927L31.6699 28.9668L29.6492 27.8001L28.1909 30.326L30.2116 31.4927Z",
    fill: "#6B758F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6888 26.2466L30.2305 23.7207L28.2097 24.8874L29.6681 27.4133L31.6888 26.2466Z",
    fill: "#6B758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministratorIcon);
export default __webpack_public_path__ + "static/media/administrator_icon.a2652f221806a2b4b7a5c20bb5365182.svg";
export { ForwardRef as ReactComponent };